export const IVA_NON_SUBJECT_LEGAL_TEXT =
    'Operación NO SUJETA A IVA en virtud del Artículo 69. Uno.1º de la Ley 37/1992 del Impuesto sobre el Valor Añadido';

const SPECIAL_PROVINCES = [
    'las palmas',
    'santa cruz de tenerife',
    'ceuta',
    'melilla',
    'palmas, las',
];

const SPECIAL_POSTAL_PREFIXES = ['35', '38', '51', '52'];

const normalizeString = (value: string): string => {
    let normalized = value.trim().toLowerCase();

    try {
        normalized = normalized.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    } catch {
        // ignore normalization errors
    }

    return normalized.replace(/\s+/g, ' ');
};

export const isSpecialTerritory = (
    province?: string | null,
    postalCode?: string | null
): boolean => {
    if (province && province.trim() !== '') {
        const normalizedProvince = normalizeString(province);

        if (SPECIAL_PROVINCES.some(
            (specialProvince) =>
                normalizedProvince === specialProvince
                || normalizedProvince.includes(specialProvince)
        )) {
            return true;
        }
    }

    if (postalCode && postalCode.trim() !== '') {
        const digits = postalCode.replace(/\D/g, '');

        if (digits.length >= 2) {
            const prefix = digits.slice(0, 2);

            if (SPECIAL_POSTAL_PREFIXES.includes(prefix)) {
                return true;
            }
        }
    }

    return false;
};

export const shouldApplyNonSubjectIvaForNonStandard = (
    receiverType: string,
    province?: string | null,
    postalCode?: string | null
): boolean => {
    if (receiverType === 'fiscal_company' || !receiverType) {
        return false;
    }

    return isSpecialTerritory(province, postalCode);
};
